module.exports = __webpack_public_path__ + "static/img/rank_284.78206a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_284.png
// module id = zoFP
// module chunks = 1